export default "__VITE_ASSET__I9Px1hVG__"